import { render, staticRenderFns } from "./ModalServiceCategory.vue?vue&type=template&id=f95a3586&scoped=true"
import script from "./ModalServiceCategory.vue?vue&type=script&lang=js"
export * from "./ModalServiceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95a3586",
  null
  
)

export default component.exports